<template>
  <div class="account-info">
    <div class="icon-title">
      <img
        :src="require('@/assets/images/userPage/user.png')"
        alt="账户信息"
        class="icon"
      />
      账户信息
    </div>
    <div class="account-info-content">
      <div
        class="account-info-content-line"
        v-for="item in accountInfo"
        :key="item.title"
      >
        <img :src="item.icon" :alt="item.title" class="info-icon" />
        <span class="info-lable">{{ item.title }}</span
        ><b>：</b><span class="note-content">{{ item.content }}</span>
      </div>
    </div>
    <div class="icon-title">
      <img
        :src="require('@/assets/images/userPage/write.png')"
        alt="充值记录"
        class="icon"
      />
      充值记录
    </div>
    <div class="list">
      <el-table
        :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }"
        :data="chargeList"
        stripe
        highlight-current-row
        class="list"
        v-loading="loading1"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="chargeTime" label="充值时间"></el-table-column>
        <el-table-column prop="chargeCount" label="充值页数"></el-table-column>
        <el-table-column prop="operator" label="操作者"></el-table-column>
        <el-table-column prop="ip" label="操作者IP"></el-table-column>
        <el-table-column prop="description" label="备注"></el-table-column>
      </el-table>
    </div>
    <div class="page-bar">
        <page-bar
        :curPage="this.curPage1"
        :pageNum="this.pageNum1"
        @changeCurPage="handleChangeCurPage1"></page-bar>
    </div>
    <!-- 消费记录 -->
    <div class="icon-title" style="margin-top:50px;">
      <img
        :src="require('@/assets/images/userPage/list.png')"
        alt="消费记录"
        class="icon"
      />
      消费记录
    </div>
    <div class="list">
      <el-table
        :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }"
        :data="expenseList"
        stripe
        highlight-current-row
        class="list"
        v-loading="loading2"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="useTime" label="扣费时间"></el-table-column>
        <el-table-column prop="bookName" label="书名"></el-table-column>
        <el-table-column prop="page" label="页码"></el-table-column>
        <el-table-column prop="ip" label="登录IP"></el-table-column>
      </el-table>
    </div>
    <div class="page-bar">
        <page-bar
        :curPage="this.curPage2"
        :pageNum="this.pageNum2"
        @changeCurPage="handleChangeCurPage2"></page-bar>
    </div>
  </div>
</template>

<script>
import PageBar from '../../components/PageBar.vue'
export default {
  components: {PageBar},
  name: 'ViewHistory',
  props: {
    config: Object
  },
  data () {
    return {
      loading1: true,
      loading2: true,
      chargePage: 0,
      remainPage: 0,
      accountInfo: [
        {
          title: '用户名',
          content: '',
          icon: require('@/assets/images/userPage/user.png')
        },
        {
          title: '充值页数',
          content: '',
          icon: require('@/assets/images/userPage/book.png')
        },
        {
          title: '剩余页数',
          content: '',
          icon: require('@/assets/images/userPage/book.png')
        },
        {
          title: '过期时间',
          content: '',
          icon: require('@/assets/images/userPage/notice.png')
        }
      ],
      expenseList: [],
      chargeList: [],
      curPage1: 1,
      curPage2: 1,
      pageNum1: 1,
      pageNum2: 1
    }
  },
  created () {
    this.getAccount()
    this.getChargeHistory()
    this.getExpenseHistory()
  },
  methods: {
    getAccount () {
      let userId = localStorage.getItem('userId')
      let url = 'retrieve/user/getUserChargeInfo?userId=' + userId
      this.$http.post(url).then(res => {
        // console.log(res.data.data)
        let deadline = res.data.data.memberDeadline
        if (deadline === null) {
          deadline = '暂无限制'
        }
        this.accountInfo[0].content = res.data.data.userName
        this.accountInfo[1].content = res.data.data.chargeTotalCount
        this.accountInfo[2].content = res.data.data.remaining
        this.accountInfo[3].content = deadline
      })
    },
    getChargeHistory () {
      let userId = localStorage.getItem('userId')
      let url = 'retrieve/charge/chargeDetail?userId=' + userId + '&pageNum=' + this.curPage1 + '&pageSize=20'
      this.$http.post(url).then(res => {
        console.log(res.data.data)
        let total = res.data.data.total
        this.pageNum1 = Math.ceil(total / 20)
        let tmp = res.data.data.chargeList
        for (let i in tmp) {
          if (tmp[i].description === 'undefined' || tmp[i].description === null) {
            tmp[i].description = ''
          }
        }
        this.chargeList = tmp
        this.loading1 = false
      })
    },
    getExpenseHistory () {
      let userId = localStorage.getItem('userId')
      let url = 'retrieve/expense/getAllExpenseLog?pageNum=' + this.curPage2 + '&pageSize=20&userId=' + userId
      this.$http.post(url).then(res => {
        // console.log(res.data.data)
        let total = res.data.data.totalCount
        this.pageNum2 = Math.ceil(total / 20)
        this.expenseList = res.data.data.expenseLogList
        this.loading2 = false
      })
    },
    handleChangeCurPage1 (page) {
      this.curPage1 = page
      this.loading1 = true
      this.getChargeHistory()
    },
    handleChangeCurPage2 (page) {
      this.curPage2 = page
      this.loading2 = true
      this.getExpenseHistory()
    }
  }
}
</script>

<style scoped>
.account-info {
  padding: 0 20px;
  padding-top: 10px;
}

.account-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.icon-title {
  display: flex;
  align-items: center;
  justify-content: left;
  border-bottom: 1px solid #9e5c1d;
  width: 156px;
  height: 50px;
  font-size: 18px;
  font-weight: bold;
  color: #9e5c1d;
}

.icon {
  width: 34px;
  margin-right: 10px;
}

.account-info-content {
  margin-left: 55px;
  margin-top: 20px;
  margin-bottom: 35px;
}

.info-icon {
  width: 18px;
  margin-right: 7px;
}

.account-info-content-line {
  display: flex;
  align-items: center;
  justify-content: left;
  margin-bottom: 18px;
  font-size: 16px;
}

.info-lable {
  width: 64px;
  font-weight: bold;
  text-align: justify;
  text-align-last: justify;
}

.note-content {
  margin-left: 10px;
  text-indent: 20px; 
  width: 500px;
  text-align: left;
  white-space: pre-wrap;
}

.list {
  height: 300px;
  overflow-y: auto;
}

.page-bar {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 10px;
}

/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.list >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.list >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/MyAccount.vue